import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import AboutCounters from "./components/AboutCounters";
import axios from "axios";
import CountUp from "react-countup";
import { t } from "../../lang/index"

const AboutSection = () => {
  const routes = all_routes;
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [totalReviews, setTotalReviews] = useState<number | null>(null);
  const about = t("home.aboutSection") as any;


  useEffect(() => {
    const fetchTotalReviews = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/public/abouts/reviews/count`);
        setTotalReviews(res.data.totalReviews);
      } catch (err) {
        console.error("Erro ao buscar total de avaliações:", err);
      }
    };
    fetchTotalReviews();
  }, [BASE_URL]);

  // Função para formatar número (ex: 1500 -> 1.5K)
  const formatNumber = (num: number) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";
    return num.toString();
  };

  return (
    <>
      {/* About Section */}
      <section className="section about-section">
        <div className="container">
          <div className="row">
            {/* Imagem e botões */}
            <div className="col-lg-6">
              <div className="about-image mb-4 mb-lg-0">
                <div className="about-listing">
                  <i className="isax isax-calendar-add text-white mb-2"></i>
                  <h6 className="fs-16 mb-3 text-white">All Listings</h6>
                  <div className="listing-img">
                    <div>
                      <ImageWithBasePath
                        src="assets/img/icons/listing.svg"
                        alt="icon"
                      />
                    </div>
                    <Link
                      to={routes.addHotel}
                      className="btn btn-warning text-gray-9"
                    >
                      Add Your Listings
                    </Link>
                  </div>
                </div>
                <div className="about-img">

                  {/*IMG DA HOME ABOUT US*/}

                </div>
                <div className="about-progress d-inline-flex align-items-center">
                  <ImageWithBasePath
                    src="assets/img/icons/progress-icon.svg"
                    alt="icon"
                  />
                  <div className="ms-2">
                    <p className="fs-10 mb-1">Today’s Earnings</p>
                    <h6 className="fs-13">$2500</h6>
                  </div>
                  <Link
                    to={routes.userWallet}
                    className="btn btn-teal btn-sm fw-normal ms-4"
                  >
                    Withdraw
                  </Link>
                </div>
              </div>
            </div>

            {/* Texto e Reviews */}
            <div className="col-lg-6">
              <div className="about-content">
                <h6 className="text-primary fs-14 fw-medium mb-2">
                  {about.welcome}
                </h6>
                <h2 className="display-6 mb-2">
                  {about.title}
                </h2>
                <p className="mb-4">
                  {about.description1}
                </p>
                <div className="d-flex align-items-center mb-4">
                  <span className="avatar avatar-xl bg-primary rounded-circle flex-shrink-0 me-3">
                    <i className="isax isax-map5 fs-24"></i>
                  </span>
                  <p>
                    {about.point1}
                  </p>
                </div>
                <div className="d-flex align-items-center">
                  <span className="avatar avatar-xl bg-secondary rounded-circle flex-shrink-0 me-3">
                    <i className="isax isax-trade5 fs-24 text-gray-9"></i>
                  </span>
                  <p>
                    {about.point2}
                  </p>
                </div>
              </div>

              {/* Parte inferior com reviews */}
              <div className="d-flex align-items-center justify-content-center flex-wrap about-btn gap-2 ">
                <Link
                  to={routes.about_us}
                  className="btn btn-white d-flex align-items-center"
                >
                  {about.learnMore}
                  <i className="isax isax-arrow-circle-right ms-2"></i>
                </Link>
                {/* Avaliações dinâmicas */}
                <div>
                  <div className="d-flex align-items-center">
                    <div className="rating d-flex align-items-center me-2">
                      <i className="fa-solid fa-star filled me-1"></i>
                      <i className="fa-solid fa-star filled me-1"></i>
                      <i className="fa-solid fa-star filled me-1"></i>
                      <i className="fa-solid fa-star filled me-1"></i>
                      <i className="fa-solid fa-star filled me-1"></i>
                      <span className="text-gray-9 fs-14">5.0</span>
                    </div>
                  </div>
                  <p className="fs-14">
                    {totalReviews !== null ? (
                      <>
                        <CountUp end={totalReviews} />+ Reviews
                      </>
                    ) : (
                      "Loading..."
                    )}
                  </p>
                </div>
              </div>
            </div>

            {/* Contadores inferiores */}
            <div className="col-md-12">
              <AboutCounters />
            </div>
          </div>

          <div className="about-bg">
            <ImageWithBasePath
              src="assets/img/bg/about-bg.png"
              alt="img"
              className="about-bg-01"
            />
            <ImageWithBasePath
              src="assets/img/bg/about-bg-01.svg"
              alt="img"
              className="about-bg-02"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;
